import React, { useState } from "react";
import {
  Button,
  ButtonBase,
  Grid,
  Typography,
  Dialog,
  DialogTitle,
  Divider,
  TextField,
  Paper,
} from "@mui/material";

import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";

import MainSectionContainer from "../../../subComponents/MainSectionContainer";
import { addNewClass, deleteClass } from "../../../firebase/functions";
import { useDispatch, useSelector } from "react-redux";
import { classesThunk } from "../../../redux/adminSlice";

const Class = () => {
  const [open, setOpen] = useState(false);
  const [className, setClassName] = useState("");

  const classesData = useSelector((state) => state.admin.classes.data);

  const handleModalChange = () => {
    setOpen((prev) => !prev);
  };
  const createEntry = () => {
    addNewClass({ name: className.toLowerCase() }).then(() => {
      console.log("New Class Entry Created");
      handleModalChange();
    });
  };
  return (
    <Grid
      container
      direction="column"
      height="100%"
      paddingTop="12px"
      bgcolor="primary.opaque">
      <Grid
        container
        item
        justifyContent="space-around"
        width="100%"
        spacing={3}>
        <Grid item>
          <Typography component="b">
            Tot. No of Classes:{" "}
            <span style={{ fontWeight: "bold" }}>{classesData.length}</span>
          </Typography>
        </Grid>
        <Grid item>
          <Button
            variant="contained"
            size="small"
            startIcon={<AddIcon />}
            onClick={handleModalChange}>
            Add a Class
          </Button>
        </Grid>
      </Grid>
      <Grid item xs>
        <MainSectionContainer>
          <Modal
            open={open}
            onClose={handleModalChange}
            createEntry={createEntry}
            className={className}
            setClassName={setClassName}
          />

          <SchoolClasses classesData={classesData} />
        </MainSectionContainer>
      </Grid>
    </Grid>
  );
};

export default Class;

const Modal = ({ onClose, open, className, setClassName, createEntry }) => {
  const handleChange = (e) => {
    setClassName(e.target.value);
  };

  return (
    <Dialog onClose={onClose} open={open}>
      <Grid
        container
        spacing={2}
        minWidth="50vw"
        maxWidth={400}
        padding="0px 16px 12px">
        <Grid item xs={12}>
          <DialogTitle>Add a Class</DialogTitle>
        </Grid>
        <Grid item xs={12}>
          <TextField
            id="standard-basic"
            name="class"
            label="Standard"
            variant="standard"
            value={className}
            fullWidth
            sx={{ textTransform: "capitalize" }}
            onChange={handleChange}
          />
        </Grid>
        <Grid item xs={12}>
          <Button
            // variant="contained"
            onClick={createEntry}
            style={{
              width: "60%",
              maxWidth: 250,
            }}>
            Create Entry
          </Button>
        </Grid>
      </Grid>
    </Dialog>
  );
};

const SchoolClasses = ({ classesData }) => {
  const dispatch = useDispatch();
  return (
    <Paper>
      {classesData.map((classData) => (
        <Grid container>
          <Grid item xs>
            <ButtonBase
              style={{ width: "100%", display: "block" }}
              component="div">
              <Typography variant="body1" padding="24px 16px" fontWeight="bold">
                {classData.name}
              </Typography>
            </ButtonBase>
          </Grid>
          <Grid item>
            <Button
              onClick={() =>
                deleteClass(classData.id).then(() => {
                  dispatch(classesThunk());
                })
              }
              startIcon={<DeleteIcon />}>
              Del
            </Button>
          </Grid>
          <Divider style={{ width: "100%" }} />
        </Grid>
      ))}
    </Paper>
  );
};
